import { useState, useRef, useEffect } from "react";

const EMOJI_GROUPS = [
  {
    label: "👕 ملابس",
    emojis: ["👕","👗","👘","🥻","👚","👖","👔","🧥","🥼","🩱","🩲","🩳","👙","👗","👒","🧢","👑","🎩","🪖","⛑️","👟","👠","👡","👢","🥾","🥿","🩴","🧤","🧣","🧦","💎","👜","👝","🎒","🧳","👓","🕶️","🥽"]
  },
  {
    label: "🏠 منزل",
    emojis: ["🛋️","🪑","🛏️","🚪","🪟","🧴","🧹","🧺","🧻","🪣","🧼","🫧","🪥","🧽","🪒","🪮","🧯","🛒","🔑","🪝","🪤","🧲","🕯️","💡","🔦","🪔","🧱","🪜","🧰","🔧","🔨","🪛","🔩","⚙️","🗑️","💌","📦","📫"]
  },
  {
    label: "✨ تنظيف",
    emojis: ["🫧","🧼","🧹","🧺","🧻","💧","🌊","♻️","✨","💦","🫙","🪣","🧴","🫗","🪒","🧽","⭐","🌟","💫","🌀","🔵","🟦","🫐","🔷","💠","🩵","🧊","🌸","🌺","🌼","🌻","🌹","🌷","🍀","☘️","🌿","🍃"]
  },
  {
    label: "👤 أشخاص",
    emojis: ["👤","👥","🧑","👩","👨","🧒","👶","🧓","👴","👵","👩‍💼","👨‍💼","🧑‍💼","👩‍🔧","👨‍🔧","🧑‍🔧","👩‍🏭","👨‍🏭","🧑‍🏭","🫅","🧑‍⚕️","👩‍⚕️","👨‍⚕️","💪","🤝","🙌","👏","🫶","❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎"]
  },
  {
    label: "🚗 توصيل",
    emojis: ["🚗","🚕","🚙","🚌","🚎","🏎️","🚑","🚐","🛻","🚚","🚛","🚜","🏍️","🛵","🚲","🛺","🚃","🚂","✈️","🛫","🛬","🚁","🛸","🚀","⛵","🛥️","🚢","📦","🗺️","🧭","📍","📌","🏁","🚩","🏳️"]
  },
  {
    label: "💰 مال",
    emojis: ["💰","💵","💴","💶","💷","💸","💳","💎","🏅","🥇","🥈","🥉","🏆","🎖️","🎗️","🎀","🎁","🎊","🎉","🎈","✅","☑️","✔️","❎","❌","⭐","🌟","💫","✨","🌈","🔥","💯","👍","🙏","💼","📊","📈","📉"]
  },
];

export default function EmojiPicker({ value, onChange, placeholder = "اختر أيقونة" }) {
  const [open, setOpen] = useState(false);
  const [activeGroup, setActiveGroup] = useState(0);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filteredEmojis = search
    ? EMOJI_GROUPS.flatMap(g => g.emojis).filter(e => e.includes(search))
    : EMOJI_GROUPS[activeGroup].emojis;

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-full bg-background border border-border rounded-xl px-3 py-2 text-sm outline-none focus:border-primary flex items-center gap-2 hover:border-primary/60 transition-colors"
      >
        <span className="text-xl">{value || "🔵"}</span>
        <span className="text-muted-foreground text-xs flex-1 text-right">{placeholder}</span>
        <span className="text-muted-foreground text-xs">▼</span>
      </button>

      {open && (
        <div className="absolute z-50 top-full mt-1 right-0 left-0 bg-card border border-border rounded-2xl shadow-2xl overflow-hidden" style={{ minWidth: 260 }}>
          {/* Search */}
          <div className="p-2 border-b border-border">
            <input
              className="w-full bg-background border border-border rounded-xl px-3 py-1.5 text-xs outline-none focus:border-primary"
              placeholder="بحث..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              autoFocus
            />
          </div>

          {/* Group tabs */}
          {!search && (
            <div className="flex overflow-x-auto scrollbar-hide border-b border-border">
              {EMOJI_GROUPS.map((g, i) => (
                <button
                  type="button"
                  key={i}
                  onClick={() => setActiveGroup(i)}
                  className={`flex-shrink-0 px-3 py-1.5 text-xs font-bold transition-colors whitespace-nowrap ${activeGroup === i ? "bg-primary/10 text-primary border-b-2 border-primary" : "text-muted-foreground hover:text-foreground"}`}
                >
                  {g.label}
                </button>
              ))}
            </div>
          )}

          {/* Emoji grid */}
          <div className="grid grid-cols-8 gap-0.5 p-2 max-h-44 overflow-y-auto">
            {filteredEmojis.map((emoji, i) => (
              <button
                type="button"
                key={i}
                onClick={() => { onChange(emoji); setOpen(false); setSearch(""); }}
                className={`text-xl p-1 rounded-lg hover:bg-secondary transition-colors aspect-square flex items-center justify-center ${value === emoji ? "bg-primary/20 ring-1 ring-primary" : ""}`}
              >
                {emoji}
              </button>
            ))}
            {filteredEmojis.length === 0 && <p className="col-span-8 text-center text-xs text-muted-foreground py-4">لا نتائج</p>}
          </div>
        </div>
      )}
    </div>
  );
}